import { useNavigate, Link } from "react-router-dom";

import SlTab from '/node_modules/@shoelace-style/shoelace/dist/react/tab';
import SlIcon from '/node_modules/@shoelace-style/shoelace/dist/react/icon';

import CancelledSubscriptionHeader from './CancelledSubscriptionHeader';

const PageHeader = ({ stripeBackground, helpLink }) => {
  let navigate = useNavigate();
  const location = window.location.href;

  const headerLink = (url, text, icon) => {
    return(
      <div className="flex-1">
        <Link to={url}>
          <SlTab>
            <SlIcon name={icon} className="header-icon-spacing"></SlIcon>
            {text}
          </SlTab>
        </Link>
      </div>
    )
  }

  const disabledLink = (text, icon) => {
    return(
      <div className="flex-1">
        <SlTab disabled>
          <strong>
            <SlIcon name={icon} className="header-icon-spacing"></SlIcon> 
            {text}
          </strong>
        </SlTab>
      </div>
    )
  }

  return(
    <>
      <div className="hide-mobile">
        <div className="flex-container" style={{ 'padding-left': '40px', 'border-bottom': `2px solid ${stripeBackground}` }}>
          { headerLink('/', 'Home', 'house') }
          { location.endsWith('/purchase_orders') ? disabledLink('Purchase Orders', 'file-earmark') : headerLink('/purchase_orders', 'Purchase Orders', 'file-earmark') }
          { location.endsWith('/orders') ? disabledLink('Store Orders', 'bag-check') : headerLink('/orders', 'Store Orders', 'bag-check') }
          { location.endsWith('/suggest') ? disabledLink('Suggest Orders', 'stars') : headerLink('/suggest', 'Suggest Orders', 'stars') } 

          { location.endsWith('/suppliers') ? disabledLink('Suppliers', 'box2') : headerLink('/suppliers', 'Suppliers', 'box2') }
          { location.endsWith('/locations') ? disabledLink('Addresses', 'upc') : headerLink('/locations', 'Addresses', 'upc') }


          { location.endsWith('/assignments') ? disabledLink('Supplier Assignments', 'diagram-3') : headerLink('/assignments', 'Supplier Assignments', 'diagram-3') }
          { location.endsWith('/settings') ? disabledLink('App Settings', 'gear') : headerLink('/settings', 'App Settings', 'gear') }
          <div className="flex-1">
            <SlTab onClick={() => navigate(-1)}>
              <SlIcon name="arrow-left" className="header-icon-spacing"></SlIcon>
              Back
            </SlTab>
          </div>
        </div>

        <div className="flex-container">
          <div className="flex-1">
            <a href={`https://athousandapps.com/${helpLink}`} target="_blank">See more details on using this page here.</a>
          </div>
        </div>

        <CancelledSubscriptionHeader />
      </div>

      <div className="only-mobile">
        <div className="flex-container" style={{ 'padding-left': '40px', 'border-bottom': `2px solid ${stripeBackground}` }}>
          { headerLink('/', 'Home', 'upc-scan') }
          <div className="flex-1">
            <SlTab onClick={() => navigate(-1)}>
              <SlIcon name="arrow-left" className="header-icon-spacing"></SlIcon>
              Back
            </SlTab>
          </div>
        </div>
      </div>
    </>
  )
}

export default PageHeader;
